import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateTopicCommunitiesRequest,
  CreateTopicCommunityRequest,
  TopicCommunity,
  TopicCommunityListItem,
  TopicCommunityQuery,
  UpdateNewsArticleTopicCommunityRequest,
  UpdateRecordingTopicCommunityRequest,
} from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TopicCommunitiesService {
  private readonly url = `${environment.bffUrl}/topic-communities`;

  constructor(private http: HttpClient) {}

  getAll(params?: TopicCommunityQuery): Observable<TopicCommunityListItem[]> {
    return this.http.get<TopicCommunityListItem[]>(this.url, { params });
  }

  createMultiple(request: CreateTopicCommunitiesRequest): Observable<TopicCommunityListItem[]> {
    return this.http.post<TopicCommunityListItem[]>(this.url, request);
  }

  createOne(type: 'recordings' | 'news-articles', body: CreateTopicCommunityRequest): Observable<TopicCommunity> {
    return this.http.post<TopicCommunity>(`${this.url}/${type}`, body);
  }

  updateNewsArticleTopicCommunity(id: string, body: UpdateNewsArticleTopicCommunityRequest): Observable<TopicCommunity> {
    return this.http.put<TopicCommunity>(`${this.url}/news-articles/${id}`, body);
  }

  updateRecordingTopicCommunity(id: string, body: UpdateRecordingTopicCommunityRequest): Observable<TopicCommunity> {
    return this.http.put<TopicCommunity>(`${this.url}/recordings/${id}`, body);
  }

  delete(type: 'recordings' | 'news-articles', id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${type}/${id}`);
  }
}
